import React, { ReactElement, useEffect } from 'react'
import Divider from '../Divider'
import MintOverview from './MintOverview'

const MintPanel = (): ReactElement => {
    useEffect(() => {
        const hash = window.location.hash
        const match = hash.match(/#mint/)
        if (!match) {
            window.location.hash = `#mint`
        }
    }, [])

    return (
        <div className="panel">
            <Divider />
            <MintOverview />
        </div>
    )
}

export default MintPanel
